/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Key type to enable.
 */
export const EnableOpenRouterKeyRequestBodyKeyType = {
  Chat: "chat",
  Internal: "internal",
} as const;
/**
 * Key type to enable.
 */
export type EnableOpenRouterKeyRequestBodyKeyType = ClosedEnum<
  typeof EnableOpenRouterKeyRequestBodyKeyType
>;

export type EnableOpenRouterKeyRequestBody = {
  /**
   * Key type to enable.
   */
  keyType: EnableOpenRouterKeyRequestBodyKeyType;
  /**
   * Organization that owns the key.
   */
  organizationId: string;
};

/** @internal */
export const EnableOpenRouterKeyRequestBodyKeyType$outboundSchema:
  z.ZodMiniEnum<typeof EnableOpenRouterKeyRequestBodyKeyType> = z.enum(
    EnableOpenRouterKeyRequestBodyKeyType,
  );

/** @internal */
export type EnableOpenRouterKeyRequestBody$Outbound = {
  key_type: string;
  organization_id: string;
};

/** @internal */
export const EnableOpenRouterKeyRequestBody$outboundSchema: z.ZodMiniType<
  EnableOpenRouterKeyRequestBody$Outbound,
  EnableOpenRouterKeyRequestBody
> = z.pipe(
  z.object({
    keyType: EnableOpenRouterKeyRequestBodyKeyType$outboundSchema,
    organizationId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      keyType: "key_type",
      organizationId: "organization_id",
    });
  }),
);

export function enableOpenRouterKeyRequestBodyToJSON(
  enableOpenRouterKeyRequestBody: EnableOpenRouterKeyRequestBody,
): string {
  return JSON.stringify(
    EnableOpenRouterKeyRequestBody$outboundSchema.parse(
      enableOpenRouterKeyRequestBody,
    ),
  );
}
